exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-action[data-v-b446d896] {\n  text-decoration: none;\n}\n.btn-action[data-v-b446d896]:hover {\n  color: #21272d;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b446d896","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/AdminContractPartnerList.vue
// module id = lnsS
// module chunks = 1